import React, { useState, forwardRef, useImperativeHandle } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import Api from '../../../__helpers/api';
import Error from '../Error';
import Success from '../Success';

//images
import loader from '../../../assets/images/contacts/loader.svg';
import { useAuthDataContext } from '../../../__providers/AuthProvider';

function Inquiry(props, ref) {

    const auth = useAuthDataContext();

    useImperativeHandle(ref, () => ({
        show: () => {
            handleShow();
        },
        hide: () => {
            handleHide();
        }
    }));

    const [data, setData] = useState({
        loading: false,
        blur: false,
        show: false,
        validations: {
            text: false
        },
        //modals
        errorOverlay: false,
        errorModal: false,
        successOverlay: false,
        successModal: false,
    });

    const handleShow = () => {
        const video = document.getElementById("video_html5_api");

        if (video) {
            video.pause();
        }

        setData(prev => ({ ...data, blur: true }));

        setTimeout(() => {
            setData(prev => ({ ...data, blur: true, show: true }));
        }, 50);

    }

    const handleHide = () => {

        const video = document.getElementById("video_html5_api");

        if (video) {
            video.play();
        }

        setData(data => ({ ...data, show: false }));

        setTimeout(() => {
            setData(data => ({ ...data, show: false, blur: false }));
            document.getElementById('text').value = ''
        }, 100);
    }

    const handleSubmit = e => {
        e.preventDefault();

        setData(prev => ({ ...prev, validations: { text: false } }));

        let data = new FormData(e.target);

        data.append('video_id', props.currentVideo);
        data.append('position', props.position);

        Api.post('student/topics/inquiry', data)
            .then(res => {

                handleHide();

                if (res.data.success) {
                    handleSuccessOk(true);

                    props.handleNewInquiry();

                } else {
                    handleErrorOk(true)
                }

            }).catch(err => {

                let _err = err.response;

                if (_err && _err.status && _err.status == 422) {

                    if (_err.data.errors.text) {
                        setData(prev => ({ ...prev, validations: { text: true } }));
                    }
                }

            });
    }

    const handleErrorOk = (bool) => {
        setData(prev => {
            return {
                ...data,
                errorModal: bool
            }
        })
        setTimeout(() => {
            setData(prev => {
                return {
                    ...data,
                    errorModal: bool,
                    errorOverlay: bool
                }
            })
        }, 100);
    }

    const handleSuccessOk = (bool) => {
        setData(data => {
            return {
                ...data,
                successModal: bool
            }
        })
        setTimeout(() => {
            setData(data => {
                return {
                    ...data,
                    successModal: bool,
                    successOverlay: bool
                }
            })
        }, 100);
    }

    let successMsg;

    if (auth.user.is_student) {
        successMsg = "Вашето запитване беше изпратено!";
    } else {
        successMsg = "Вашата препоръка беше изпратена!";
    }

    return (
        <>
            <div ref={ref} id="overlay" className={data.blur ? 'visible' : ''}>
                <form className={`box settings ${data.show ? 'show' : ''}`} style={{ maxWidth: '800px' }} onSubmit={handleSubmit}>
                    <h3>
                        {auth.user.is_student
                            ? 'Изпращане на въпрос към темата'
                            : 'Изпращане на препоръка към темата'
                        }
                    </h3>
                    <p>
                        {auth.user.is_student
                            ? 'Тук може да зададеш своя въпрос свързан с темата.'
                            : 'Тук може да зададете препоръка свързана с темата.'
                        }
                    </p>
                    <br />
                    <div className="fields">
                        <TextField
                            id="text"
                            name="text"
                            error={data.validations.text ? true : false}
                            label="Съобщение*"
                            placeholder="Въведете съобщение..."
                            fullWidth
                            multiline
                            rows="6"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                    {!data.loading ?
                        <div className="buttons">
                            <Button className="cancel-request" onClick={handleHide}>
                                Отказ
                            </Button>
                            <Button type="submit" className="accept-request">
                                Изпращане
                            </Button>
                        </div>
                        :
                        <img src={loader} alt="loader" className="loader" />
                    }
                </form>
            </div>
            <Success
                blur={data.successOverlay}
                popup={data.successModal}
                mainMessage={successMsg}
                secondaryMessage="Очаквайте да се свържем с Вас."
                acceptCallback={handleSuccessOk}
            />
            <Error
                blur={data.errorOverlay}
                popup={data.errorModal}
                mainMessage="Нещо се обърка!"
                secondaryMessage="Моля, проверете въведените данни."
                acceptCallback={handleErrorOk}
            />
        </>
    )
}

export default forwardRef(Inquiry);